<template>
  <div class="card">
    <div class="card-header">
      <div class="header-card-left pull-left text-bold">
        {{ category && category.category && category.category.category }}
      </div>
      <div class="header-card-right pull-right">
        <router-link :to="'/categories/' + category.category.id">Xem thêm</router-link>
      </div>
      <div class="clearfix"/>
    </div>
    <div class="card-body col-12">
      <flickity
        v-if="category && category.items && category.items.length > 0"
        ref="flickity"
        :options="flickityOptions"
        class="flickity">
        <div
          v-for="item in category.items"
          class="card carousel-cell">
          <product-item :item="item" />
        </div>
      </flickity>
    </div>
  </div>
</template>

<script>
  import Flickity from 'vue-flickity'
  import ProductItem from "./ProductItem";

  export default {
    name: "CategoryItem",
    components: {
      Flickity,
      ProductItem
    },
    props: ["category"],
    data: function () {
      return {
        flickityOptions: {
          initialIndex: 4,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          freeScroll: true,
        }
      }
    }
  }
</script>

<style scoped>
  .carousel-cell {
    width: 50%;
    height: 500px;
    margin-right: 10px;
    background: white;
    border-radius: 5px;
  }
  .card{
    margin-top: 0;
    border: none;
  }
  .card-header{
    border-bottom: none;
  }
  .header-card-right a{
    color: #4CAF50;
    font-size: 0.8rem;
    margin-right:10px ;
  }

</style>



// WEBPACK FOOTER //
// src/components/categories/CategoryItem.vue